<template>
    <div class="wrap wrap--products">
        <!-- 헤더 -->
        <main-header :header-type="'shop'"></main-header>
        <!-- 메인 -->
        <main class="main" role="main">
            <div class="product-list-container" data-category-sidebar="opened">
                <!-- 상품 카테고리 -->
                <shop-categories :_category="_category" :store="store" />

                <!-- 상품 리스트 -->
                <section class="product-lists">
                    <div class="product-lists__inner">
                        <!-- 업체페이지용 정보 (모바일에서만 표시) -->
                        <shop-brand-card v-if="store" :store="store"></shop-brand-card>

                        <!-- 쇼핑몰 비주얼 -->
                        <category-banners :category="category"></category-banners>

                        <!-- 새집 추천 PICK -->
                        <category-pickups :category="category"></category-pickups>

                        <!-- 상품 리스트 시작 -->
                        <div class="product-lists__head">
                            <!-- 라우터 (Breadcrumb) -->
                            <category-breadcrumb :_category="_category" />
                            <div class="product-lists__filter">
                                <div class="product-lists__total">
                                    <span
                                        >총 <em>{{ totalCount.format() }}</em
                                        >개 상품</span
                                    >
                                </div>
                                <div class="lists-option">
                                    <select class="select select--orange select--underline">
                                        <option value="">인기순</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="product-lists__body">
                            <div class="grid">
                                <div v-for="(product, index) in products" :key="index" class="grid-5">
                                    <shop-product-item :value="product"></shop-product-item>
                                </div>
                            </div>

                            <div class="product-lists__pagination">
                                <pagination-component v-model="page" :count="pageCount" @input="search()"></pagination-component>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>

        <!-- 푸터 -->
        <main-footer></main-footer>
    </div>
</template>

<script>
import api from "@/api";

import MainHeader from "@/components/client/inc/main-header.vue";
import MainFooter from "@/components/client/inc/main-footer.vue";
import CategoryBanners from "@/components/client/shop/category-banners.vue";
import CategoryPickups from "@/components/client/shop/category-pickups.vue";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import ShopCategories from "@/components/client/shop/shop-categories.vue";
import ShopProductItem from "@/components/client/shop/product-item.vue";
import ShopBrandCard from "@/components/client/shop/shop-brand-card.vue";
import CategoryBreadcrumb from "@/components/client/shop/category-breadcrumb.vue";
import { mapState } from "vuex";

export default {
    components: {
        MainHeader,
        MainFooter,
        CategoryBanners,
        CategoryPickups,
        ShopCategories,
        ShopProductItem,
        PaginationComponent,
        ShopBrandCard,
        CategoryBreadcrumb,
    },
    props: {
        _store: String,
        _category: String,
    },
    metaInfo() {
        return Object.assign({}, this.seo);
    },
    data() {
        return {
            store: null,

            page: 1,
            pageCount: 0,
            limit: 24,
            totalCount: 0,

            products: [],
        };
    },
    computed: {
        ...mapState("shop", { categories: (state) => state.categories }),
        filter() {
            return {
                _store: this._store,
                _category: this._category,
            };
        },
        category() {
            return (this.categories || []).find(({ _id }) => _id == this._category);
        },
        seo() {
            return this.category?.seoEnabled ? this.category?.seo : {};
        },
    },
    mounted() {
        this.setStore();
    },
    methods: {
        async setStore() {
            try {
                if (this._store) {
                    var { store } = await api.v1.shop.stores.getStore({
                        _id: this._store,
                    });
                    this.store = store;
                } else this.store = null;
                this.search(false);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({}, { page: this.page }),
                    });
                }

                var { summary, products } = await api.v1.shop.products.getProducts({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.products = products;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
                this.totalCount = summary.totalCount;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    watch: {
        _store() {
            this.setStore();
        },
        _category() {
            this.search(false);
        },
    },
};
</script>
